module.exports = __webpack_public_path__ + "conheca/static/media/marcador3.487c0e35.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/marcador3.png
// module id = 331
// module chunks = 37